import { useCallback, useState } from 'react';

export default function useFieldModalController({ canEdit = true } = {}) {
  const [fieldModalOpen, setFieldModalOpen] = useState(false);
  const [fieldInsertIndex, setFieldInsertIndex] = useState(null);
  const [fieldEditingField, setFieldEditingField] = useState(null);

  const handleFieldModalOpen = useCallback((open) => {
    setFieldModalOpen(open);
    if (!open) {
      setFieldInsertIndex(null);
      setFieldEditingField(null);
    }
  }, []);

  const handleAddFieldClick = useCallback((index) => {
    if (!canEdit) return;
    setFieldInsertIndex(index);
    setFieldEditingField(null);
    setFieldModalOpen(true);
  }, [canEdit]);

  const handleSettingsClick = useCallback((field) => {
    if (!field || !canEdit) return;
    setFieldEditingField(field);
    setFieldInsertIndex(null);
    setFieldModalOpen(true);
  }, [canEdit]);

  const resetFieldModalState = useCallback(() => {
    setFieldModalOpen(false);
    setFieldInsertIndex(null);
    setFieldEditingField(null);
  }, []);

  return {
    fieldModalOpen,
    fieldInsertIndex,
    fieldEditingField,
    handleFieldModalOpen,
    handleAddFieldClick,
    handleSettingsClick,
    resetFieldModalState,
  };
}